import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_2 = ["for"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須", -1)
const _hoisted_4 = {
  key: 0,
  class: "block p-error text-sm"
}

import moment from "moment";
import { get, set } from "@vueuse/core";
import { ValidateError } from "async-validator";
import { computed, reactive, withDefaults, onBeforeMount, onUpdated } from "vue";
import * as _ from "lodash";
import { useChangeCase } from "@vueuse/integrations/useChangeCase";
import { BookingHourOptions } from "@/clinic/typings/enums/booking";
import TimeUtils from "@/clinic/utils/time-utils";
import { DropdownChangeEvent } from "primevue/dropdown";

type ITimeField = {
  name: string;
  date: string;
  value: string | null;
  fieldLabel: string;
  errorFields: Record<string, ValidateError[]>;
  duration: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'time',
  props: {
    name: { default: "start_time" },
    date: { default: TimeUtils.formatDateYMD(new Date().toString()) },
    value: { default: null },
    fieldLabel: { default: "予約時間" },
    errorFields: null,
    duration: { default: 5 }
  },
  emits: ["changingHour", "changingMinute"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { name: string, date: string, value: string | null, fieldLabel: string, errorFields: Record<string, ValidateError[]>, duration: number };

const bookingMinuteOptions = computed(() => generateBookingMinuteOptions(props.duration));

const generateBookingMinuteOptions = (duration: number) => {
  if (duration > 60) duration = duration % 60;

  return Array.from({ length: 60 / duration }, (_, i) => {
    const time = `${(i * duration).toString().padStart(2, "0")}`;
    return { name: time + "分", value: time };
  });
};



const form = reactive<{ hour: string | null; minute: string | null }>({
  hour: null,
  minute: null,
});


const getDateTime = computed(() =>
  `${moment(get(props.date)).format("YYYY/MM/DD")} ${get(form.hour)}:${get(form.minute)}`.trim()
);

const onChangingHour = ({ value }: DropdownChangeEvent) => {
  set(form, "hour", value);
  emits("changingHour", get(getDateTime));
};

const onChangingMinute = ({ value }: DropdownChangeEvent) => {
  set(form, "minute", value);
  emits("changingMinute", get(getDateTime));
};

const nameField = computed(() => get(useChangeCase(props.name || "", "camelCase")));

const roundMinute = (min: number) => String(Math.round(min / 5) * 5).padStart(2, "0");

const loadTime = () => {
  if ((!form.hour || !form.minute) && props?.value) {
    const [hour, minute] = props.value.split(":");
    set(form, "hour", hour);
    set(form, "minute", roundMinute(parseInt(minute)));
  }
};

const setFormTime = (hour: string, minute: string) => {
  set(form, "hour", hour);
  set(form, "minute", roundMinute(parseInt(minute)));
};

onBeforeMount(() => loadTime());

onUpdated(() => loadTime());

// eslint-disable-next-line no-undef
expose({
  setFormTime,
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "mb-2",
      for: __props.name
    }, [
      _createTextVNode(_toDisplayString(__props.fieldLabel), 1),
      _hoisted_3
    ], 8, _hoisted_2),
    _createVNode(_component_InputText, {
      name: __props.name,
      class: "hidden",
      value: _unref(getDateTime)
    }, null, 8, ["name", "value"]),
    _createVNode(_component_Dropdown, {
      modelValue: form.hour,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.hour) = $event)),
      options: _unref(BookingHourOptions),
      optionLabel: "name",
      optionValue: "value",
      class: "mr-2 max-w-6rem font-normal",
      inputProps: { class: 'font-light text-black20 text-sm' },
      onChange: onChangingHour
    }, null, 8, ["modelValue", "options"]),
    _createTextVNode(" : "),
    _createVNode(_component_Dropdown, {
      modelValue: form.minute,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.minute) = $event)),
      options: _unref(bookingMinuteOptions),
      optionLabel: "name",
      optionValue: "value",
      class: "mr-2 ml-2 max-w-6rem font-normal",
      inputProps: { class: 'font-light text-black20 text-sm' },
      onChange: onChangingMinute
    }, null, 8, ["modelValue", "options"]),
    (__props.errorFields[_unref(get)(_unref(nameField))]?.length > 0)
      ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_.head(__props.errorFields[_unref(get)(_unref(nameField))])?.message), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})